// extracted by mini-css-extract-plugin
module.exports = {"password-change__wrapper":"PasswordChange_password-change__wrapper__3_PXq","password-change__button":"PasswordChange_password-change__button__1MsHK"};